import React, { useRef, useState } from 'react';
import chatStyle from 'styles/css/Chat.module.scss';
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { WEBSITE, API_HISTORY_CHAT, BASE_SITE, API_REG_NEW_MSG } from 'apis';
import { handleChangeDataHistoryChatPage } from 'reduxx/actions/pages/myAdvice/chat';
import { handleSetBackdropLoading, handleChangeBackdropLoadingData } from 'reduxx/actions/loaders';
import { handleSetOpenCustomSnackbar } from 'reduxx/actions/snackbar';
import apiRequest from 'utils/apiRequest';
import imageCompression from 'browser-image-compression';

const WhatsAppChat = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { uniqueCode } = useParams();

    const { token } = useSelector(state => state.login);
    const { isBackdropLoading } = useSelector(state => state.allLoaders);
    const { info, chat, inputText, attachFile, filePreview, isRecording, audioBlob, recordState, recordTime, isMicPressed } = useSelector(state => state.historyChat);


    useEffect(() => {

        const setVH = () => {
            const vh = window.visualViewport
                ? window.visualViewport.height * 0.01
                : window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };

        setVH();
        window.visualViewport?.addEventListener('resize', setVH);
        window.addEventListener('resize', setVH);

        return () => {
            window.visualViewport?.removeEventListener('resize', setVH);
            window.removeEventListener('resize', setVH);
        };
    }, []);


    useEffect(() => {
        if(uniqueCode !== null)
            apiHistoryChat();
    }, [uniqueCode]);


    const apiHistoryChat = () => {
        apiRequest({
            dispatch,
            endpoint: API_HISTORY_CHAT,
            method: 'post',
            data: {width: window.innerWidth, visitCode: uniqueCode},
            ...(token && { token }),
            successMessage: null,
            onSuccess: (res) => {
                dispatch(handleChangeDataHistoryChatPage('info', res.info));
                dispatch(handleChangeDataHistoryChatPage('chat', res.chat));

                scrollToBottom();
            }
        });
    };

    const toPersianDigits = (num) => {
        return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
    };

    const handleChangeInputs = (event) => {
        const {name, value} = event.target;
        dispatch(handleChangeDataHistoryChatPage(name, value));
    };

    // const handleSendMessage = async () => {
    //     const formData = new FormData();

    //     formData.append('visitCode', uniqueCode);
    //     formData.append('width', window.innerWidth);


    //     if (inputText) {
    //         formData.append('text', inputText);
    //     }

    //     if (attachFile) {
    //         formData.append('file', attachFile);
    //     }

    //     if (audioBlob) {
    //         formData.append('voice', audioBlob, 'voice.webm');
    //     }

    //     apiRequest({
    //         dispatch,
    //         endpoint: API_REG_NEW_MSG,
    //         method: 'post',
    //         data: formData,
    //         isForm: true,
    //         ...(token && { token }),
    //         onSuccess: () => {
    //             dispatch(handleChangeDataHistoryChatPage('inputText', ''));
    //             dispatch(handleChangeDataHistoryChatPage('attachFile', false));
    //             dispatch(handleChangeDataHistoryChatPage('filePreview', null));
    //             dispatch(handleChangeDataHistoryChatPage('audioBlob', null));

    //             apiHistoryChat();
    //         }
    //     });
    // };

    const handleSendMessage = async () => {
        if(isBackdropLoading) return;

        if (!attachFile && audioBlob === null && inputText.trim().length === 0) {
            // dispatch(handleSetOpenCustomSnackbar(true, {message: 'لطفا تصویر فاکتور را انتخاب کنید', severity: 'error', vertical: 'top', horizontal: 'center'}));  
            return;
        }


        const formData = new FormData();
        formData.append('visitCode', uniqueCode);
        formData.append('width', window.innerWidth);

        if (inputText) {
            formData.append('text', inputText);
        }

        

        if (audioBlob) {
            formData.append('voice', audioBlob, 'voice.webm');            
        }
        else if (attachFile) {
            formData.append('file', attachFile);
        }

        try {
            dispatch(handleSetBackdropLoading(true));

            const response = await fetch(BASE_SITE + API_REG_NEW_MSG, {
                method: 'POST',
                headers: {
                    'Authorization': token, 
                },
                body: formData,
            });

            const result = await response.json();

            if(response.ok) {
                if(result.status === 'ok') {
                    dispatch(handleChangeDataHistoryChatPage('inputText', ''));
                    dispatch(handleChangeDataHistoryChatPage('attachFile', false));
                    dispatch(handleChangeDataHistoryChatPage('filePreview', null));
                    dispatch(handleChangeDataHistoryChatPage('audioBlob', null));

                    apiHistoryChat();
                }
                else if(result.status === 'error') {
                    dispatch(handleSetOpenCustomSnackbar(true, {message: result.message, severity: 'error', vertical: 'top', horizontal: 'center'}));  
                }
            }
            else {
                dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور.لطفا دقایقی دیگر تلاش کنید', severity: 'error', vertical: 'top', horizontal: 'center'}));  
            }
            dispatch(handleSetBackdropLoading(false));
        } catch (err) {
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور.لطفا دقایقی دیگر تلاش کنید', severity: 'error', vertical: 'top', horizontal: 'center'}));  
            dispatch(handleSetBackdropLoading(false));
        } finally {
            dispatch(handleSetBackdropLoading(false));
        }
    };


    const fileInputRef = useRef(null);
    const handleButtonClick = () => {
        fileInputRef.current.click();
    };


    const pressActiveRef = useRef(false);      // آیا هنوز انگشت روی دکمه است؟
    const stopRequestedRef = useRef(false);    // اگر قبل از شروع، stop خورد
    const pressStartedAtRef = useRef(0);       // برای حداقل زمان
    const MIN_MS = 400;                        // حداقل زمان قابل قبول (به دلخواه)
    const MIN_BYTES = 2000;                    // حداقل حجم قابل قبول (به دلخواه)


    const resizeImageFast = (file, maxSize = 800) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            const url = URL.createObjectURL(file);

            img.onload = () => {
                let { width, height } = img;

                if (width > height && width > maxSize) {
                    height = Math.round(height * (maxSize / width));
                    width = maxSize;
                } else if (height > maxSize) {
                    width = Math.round(width * (maxSize / height));
                    height = maxSize;
                }

                const canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;

                const ctx = canvas.getContext('2d', { alpha: false });
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob(
                    blob => {
                        URL.revokeObjectURL(url);
                        if (!blob) return reject();
                        resolve(new File([blob], file.name, { type: 'image/jpeg' }));
                    },
                    'image/jpeg',
                    0.75
                );
            };

            img.onerror = reject;
            img.src = url;
        });
    };

    const compressLight = async (file) => {
        if (file.size < 200 * 1024) return file;

        return await imageCompression(file, {
            maxSizeMB: 0.2,
            useWebWorker: true,
            initialQuality: 0.7,
        });
    };


    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        dispatch(handleChangeBackdropLoadingData(true, 'در حال آماده‌سازی تصویر...'));

        try {
            let processed = file;

            if (file.type.startsWith('image/')) {
                // ⚡ FAST resize first (Android safe)
                processed = await resizeImageFast(file, 800);

                // 🔽 optional compress
                processed = await compressLight(processed);
            }

            dispatch(handleChangeDataHistoryChatPage('attachFile', processed));
            dispatch(handleChangeDataHistoryChatPage(
                'filePreview',
                URL.createObjectURL(processed)
            ));

        } catch (e) {
            console.error(e);
            dispatch(handleChangeDataHistoryChatPage('attachFile', file));
        } finally {
            dispatch(handleChangeBackdropLoadingData(false, ''));
        }
    };


    const removeSelectedFile = () => {
        dispatch(handleChangeDataHistoryChatPage('attachFile', false));
        dispatch(handleChangeDataHistoryChatPage('filePreview', null));
        dispatch(handleChangeDataHistoryChatPage('audioBlob', null));
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };



    const hasText = inputText.trim().length > 0;
    const hasFile = !!attachFile;


    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);
    const streamRef = useRef(null);
    const timerRef = useRef(null);
    const recordTimeRef = useRef(0);
    const isStartingRef = useRef(false); // جلوگیری از دوبار start شدن

    const [micHint, setMicHint] = useState(false);
    const micHintTimerRef = useRef(null);
    const showMicHint = () => {
        setMicHint(true);
        if (micHintTimerRef.current) clearTimeout(micHintTimerRef.current);
        micHintTimerRef.current = setTimeout(() => setMicHint(false), 1200);
    };
    useEffect(() => {
        return () => {
            if (micHintTimerRef.current) clearTimeout(micHintTimerRef.current);
        };
    }, []);
    const pressDownAtRef = useRef(0);
    const HINT_TAP_MS = 250;


    const startRecording = async () => {
        if (isRecording || isStartingRef.current) return;

        
        isStartingRef.current = true;
        stopRequestedRef.current = false;
        pressStartedAtRef.current = Date.now();


        cleanupRecording(); // تضمین تمیزی

        dispatch(handleChangeDataHistoryChatPage('isMicPressed', true));

        try {
            // iOS/Safari: حتما باید از gesture کاربر باشد (PointerDown عالیه)
            const stream = await navigator.mediaDevices.getUserMedia({
                audio: {
                    echoCancellation: true,
                    noiseSuppression: true,
                    autoGainControl: true,
                }
            });


            // ✅ اگر کاربر تا این لحظه انگشت را برداشته یا stop درخواست شده، اصلاً شروع نکن
            if (!pressActiveRef.current || stopRequestedRef.current) {
                stream.getTracks().forEach(t => t.stop());
                cleanupRecording();
                return;
            }


            streamRef.current = stream;

            const mimeType = getBestAudioMimeType();
            if (mimeType === null) {
                // MediaRecorder اصلاً وجود ندارد (iOS قدیمی و بعضی مرورگرها)
                throw new Error('MediaRecorder is not supported on this browser.');
            }

            const mediaRecorder = new MediaRecorder(stream, mimeType ? { mimeType } : undefined);
            mediaRecorderRef.current = mediaRecorder;
            audioChunksRef.current = [];

            mediaRecorder.ondataavailable = (e) => {
                if (e.data && e.data.size > 0) audioChunksRef.current.push(e.data);
            };

            mediaRecorder.onstop = () => {
                try {
                    const finalType = mediaRecorder.mimeType || (mimeType || 'audio/webm');
                    const blob = new Blob(audioChunksRef.current, { type: finalType });


                    const durationMs = Date.now() - pressStartedAtRef.current;
                    // ✅ اگر خیلی کوتاه/خیلی کم‌حجم بود، discard کن (مشکل 2 حل میشه)
                    if (durationMs < MIN_MS || blob.size < MIN_BYTES) {
                        dispatch(handleChangeDataHistoryChatPage('audioBlob', null));
                        dispatch(handleChangeDataHistoryChatPage('attachFile', false));
                        return;
                    }


                    // ✅ Blob را به File تبدیل کن تا filename داشته باشد
                    const ext =
                        finalType.includes('mp4') ? 'mp4' :
                        finalType.includes('aac') ? 'aac' :
                        finalType.includes('webm') ? 'webm' : 'dat';

                    const audioFile = new File([blob], `voice.${ext}`, { type: finalType });

                    dispatch(handleChangeDataHistoryChatPage('attachFile', audioFile));
                    dispatch(handleChangeDataHistoryChatPage('audioBlob', blob));
                    dispatch(handleChangeDataHistoryChatPage('filePreview', null));
                } finally {
                    // آزادسازی میکروفن
                    if (streamRef.current) {
                        streamRef.current.getTracks().forEach(t => t.stop());
                        streamRef.current = null;
                    }
                }
            };

            mediaRecorder.start(); // می‌تونی timeslice هم بدی: mediaRecorder.start(250);
            dispatch(handleChangeDataHistoryChatPage('isRecording', true));
            dispatch(handleChangeDataHistoryChatPage('recordState', 'recording'));

            // ✅ تایمر بدون stale closure
            recordTimeRef.current = 0;
            dispatch(handleChangeDataHistoryChatPage('recordTime', 0));

            timerRef.current = setInterval(() => {
                recordTimeRef.current += 1;
                dispatch(handleChangeDataHistoryChatPage('recordTime', recordTimeRef.current));
            }, 1000);

        } catch (err) {
            console.error(err);
            // پیشنهاد: اینجا snackbar هم بده
            // dispatch(handleSetOpenCustomSnackbar(true, { message: 'مرورگر شما ضبط صدا را پشتیبانی نمی‌کند یا دسترسی میکروفن داده نشده است.', severity:'error', ... }))
            cleanupRecording();
        } finally {
            isStartingRef.current = false;

            // ✅ اگر در این فاصله stop خورده بود و ضبط شروع هم شده بود، stop کن
            // (گاهی در برخی مرورگرها به race می‌خوره)
            if (stopRequestedRef.current && mediaRecorderRef.current?.state === 'recording') {
              stopRecording();
            }
        }
    };

    const stopRecording = () => {
        dispatch(handleChangeDataHistoryChatPage('isMicPressed', false));

        stopRequestedRef.current = true; // ✅ مهم

        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }

        const mr = mediaRecorderRef.current;
        // ✅ اگر هنوز mediaRecorder ساخته نشده (permission در حال انجام است)، کاری نکن
        if (!mr) {
            // cleanup هم نکن چون start خودش بعداً stream را stop می‌کند
            dispatch(handleChangeDataHistoryChatPage('isRecording', false));
            dispatch(handleChangeDataHistoryChatPage('recordState', 'idle'));
            return;
        }
        if (mr && mr.state !== 'inactive') {
            try { mr.stop(); } catch (e) {}
        }

        mediaRecorderRef.current = null;
        dispatch(handleChangeDataHistoryChatPage('isRecording', false));
        dispatch(handleChangeDataHistoryChatPage('recordState', 'idle'));
        // recordTime را اینجا صفر نکن اگر می‌خوای زمان ضبط باقی بماند؛
        // اگر می‌خوای ریست شود:
        // dispatch(handleChangeDataHistoryChatPage('recordTime', 0));
    };

    const cleanupRecording = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }

        const mr = mediaRecorderRef.current;
        if (mr && mr.state !== 'inactive') {
            try { mr.stop(); } catch (e) {}
        }
        mediaRecorderRef.current = null;

        if (streamRef.current) {
            streamRef.current.getTracks().forEach(t => t.stop());
            streamRef.current = null;
        }

        audioChunksRef.current = [];
        recordTimeRef.current = 0;

        dispatch(handleChangeDataHistoryChatPage('recordState', 'idle'));
        dispatch(handleChangeDataHistoryChatPage('recordTime', 0));
    };

    const getBestAudioMimeType = () => {
        const candidates = [
            'audio/webm;codecs=opus',  // Chrome/Android عالی
            'audio/webm',
            'audio/mp4',               // بعضی iOS ها
            'audio/aac',
        ];

        if (!window.MediaRecorder) return null;

        for (const t of candidates) {
            try {
                if (MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported(t)) return t;
            } catch (e) {}
        }

        // اگر isTypeSupported نبود یا چیزی نپذیرفت
        return '';
    };


    const messagesEndRef = useRef(null);
    const scrollToBottom = () => {
        setTimeout(() => {
            messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 100);
    };

    return (
        <div className={chatStyle['chat-page']}>
            {/* بالای صفحه: هدر چت */}
            <header className={chatStyle['chat-header']}>
                <div className={chatStyle['chat-header-left']}>
                    <button onClick={() => navigate(-1)} className={chatStyle['back-button']} style={{display: 'flex'}} aria-label="Back">
                        <svg style={{width: '24px', height: '24px', fill: 'black', verticalAlign: 'inherit', rotate: '180deg'}}>
                            <use xlinkHref="#arrowLeft"></use>
                        </svg>
                    </button>
                    <div className={chatStyle['avatar-wrapper']}>
                        <img src={`${WEBSITE}/images/doctors/${info.doctorImage}`} alt={info.doctorName} className={chatStyle['avatar-circle']} />
                    </div>
                    <div className={chatStyle['chat-info']}>
                        <div className={chatStyle['chat-name']}>{info.doctorName}</div>
                        <div className={chatStyle['chat-status']}>{info.expertise}</div>
                    </div>
                </div>
            </header>

            {/* پس‌زمینه + محتوای چت */}
            <div className={chatStyle['chat-body-wrapper']} style={{direction: 'ltr'}}>
                <div className={chatStyle['chat-body-overlay']} />
                <main className={chatStyle['chat-body']}>
                    {
                        chat.map((chatItem, index) => (
                            <>
                            {/* نوار تاریخ */}
                            <div className={chatStyle['date-chip-wrapper']}>
                                <div className={chatStyle['date-chip']}>{toPersianDigits(chatItem.date)}</div>
                            </div>
                            {
                                chatItem.messages.map((message, msgIndex) => {
                                    if(message.isUser) {
                                        return (
                                            <div
                                                className={[
                                                    chatStyle['message-row'],
                                                    chatStyle['message-row--sent'],
                                                ].join(' ')}
                                            >
                                                <div
                                                    className={[
                                                        chatStyle['message-bubble'],
                                                        chatStyle['message-bubble--sent'],
                                                    ].join(' ')}
                                                >
                                                    <span className={chatStyle['message-text']}>
                                                    { message.type === "text" ?
                                                        (message.text)
                                                        : message.type === "image" ?
                                                        <a href={`${WEBSITE}${message.filePath}`} target="_blank">
                                                            <img src={`${WEBSITE}${message.filePath}`} style={{maxWidth: '200px', maxHeight: '200px'}} />
                                                        </a>
                                                        : message.type === "audio" ?
                                                        <audio controls src={`${WEBSITE}${message.filePath}`} />
                                                        :
                                                        ""
                                                    }
                                                    </span>
                                                    <div className={chatStyle['message-meta']}>
                                                        <span className={chatStyle['message-time']}>{toPersianDigits(message.time)}</span>
                                                        {/*<span className={chatStyle['message-status']}>✔✔</span>*/}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }
                                    else {
                                        return (
                                            <div
                                                className={[
                                                    chatStyle['message-row'],
                                                    chatStyle['message-row--received'],
                                                ].join(' ')}
                                            >
                                                <div
                                                    className={[
                                                        chatStyle['message-bubble'],
                                                        chatStyle['message-bubble--received'],
                                                    ].join(' ')}
                                                >
                                                    <span className={chatStyle['message-text']}>
                                                    { message.type === "text" ?
                                                        (message.text)
                                                        : message.type === "image" ?
                                                        <a href={`${WEBSITE}${message.filePath}`} target="_blank">
                                                            <img src={`${WEBSITE}${message.filePath}`} style={{maxWidth: '200px', maxHeight: '200px'}} />
                                                        </a>
                                                        : message.type === "audio" ?
                                                        <audio controls src={`${WEBSITE}${message.filePath}`} />
                                                        :
                                                        ""
                                                    }
                                                    </span>
                                                    <div className={chatStyle['message-meta']}>
                                                        <span className={chatStyle['message-time']}>{toPersianDigits(message.time)}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }
                                })
                            }
                            </>
                        ))
                    }

                    <div ref={messagesEndRef} />
                </main>
            </div>

            {/* پایین صفحه: نوار تایپ پیام */}
            {info.status !== "done" &&
                <footer className={chatStyle['chat-footer']}>
                    <div className={chatStyle['chat-footer-inner']}>

                        {attachFile ?
                            <button 
                                    className={[
                                        chatStyle['icon-button'], 
                                        chatStyle['icon-button--white'],
                                    ].filter(Boolean).join(' ')} 
                                    onClick={removeSelectedFile}
                            >
                                <svg width="18" height="18" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill="red" d="m9.129 0 1.974.005c.778.094 1.46.46 2.022 1.078.459.504.7 1.09.714 1.728h5.475a.69.69 0 0 1 .686.693.69.69 0 0 1-.686.692l-1.836-.001v11.627c0 2.543-.949 4.178-3.041 4.178H5.419c-2.092 0-3.026-1.626-3.026-4.178V4.195H.686A.69.69 0 0 1 0 3.505c0-.383.307-.692.686-.692h5.47c.014-.514.205-1.035.554-1.55C7.23.495 8.042.074 9.129 0m6.977 4.195H3.764v11.627c0 1.888.52 2.794 1.655 2.794h9.018c1.139 0 1.67-.914 1.67-2.794zM6.716 6.34c.378 0 .685.31.685.692v8.05a.69.69 0 0 1-.686.692.69.69 0 0 1-.685-.692v-8.05c0-.382.307-.692.685-.692m2.726 0c.38 0 .686.31.686.692v8.05a.69.69 0 0 1-.686.692.69.69 0 0 1-.685-.692v-8.05c0-.382.307-.692.685-.692m2.728 0c.378 0 .685.31.685.692v8.05a.69.69 0 0 1-.685.692.69.69 0 0 1-.686-.692v-8.05a.69.69 0 0 1 .686-.692M9.176 1.382c-.642.045-1.065.264-1.334.662-.198.291-.297.543-.313.768l4.938-.001c-.014-.291-.129-.547-.352-.792-.346-.38-.73-.586-1.093-.635z"/></svg>
                            </button>
                            :
                            <button onClick={handleButtonClick} className={chatStyle['icon-button']} aria-label="Attach">
                                📎
                            </button>
                        }

                        <input
                            type="file"
                            accept="image/*,.pdf"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                        />


                        {/* preview فایل */}
                        {attachFile && (
                            <div className={chatStyle['file-preview']}>
                                { filePreview ? (
                                    <img src={filePreview} alt="preview" />
                                ) : audioBlob ? (
                                    <audio controls src={URL.createObjectURL(audioBlob)} />
                                ) : (
                                    <span>{attachFile.name}</span>
                                )}
                            </div>
                        )}

                        { !attachFile && audioBlob === null &&
                        <div className={chatStyle['input-wrapper']}>
                            <input
                                type="text"
                                name="inputText"
                                value={inputText}
                                onChange={handleChangeInputs}
                                placeholder="متن خود را بنویسید"
                                className={chatStyle['chat-input']}
                            />
                        </div>
                        }

                        {recordState !== 'idle' && (
                            <div className={chatStyle.recordOverlay} style={{marginLeft: '30px'}}>
                                <div className={chatStyle.timer}>
                                    ⏱ {recordTime}s
                                </div>
                            </div>
                        )}



                        <div className={chatStyle.micWrap}>
                            {micHint && (
                                <div className={chatStyle.micHint}>
                                  برای ضبط صدا، دکمه را نگه دارید
                                </div>
                            )}
                        </div>


                        {!hasText && !hasFile ? (
                            /* 🎤 میکروفن */
                            <button 
                                    className={[
                                        chatStyle['icon-button'], 
                                        chatStyle['icon-button--primary'],
                                        chatStyle['icon-button--mic'],
                                        isMicPressed && chatStyle['icon-button--mic-pressed']
                                    ].filter(Boolean).join(' ')} 
                                    aria-label="Record"

                                    onPointerDown={(e) => {
                                        e.preventDefault(); // جلوگیری از text selection/callout
                                        pressDownAtRef.current = Date.now();
                                        // خیلی مهم برای iOS: gesture کاربر حفظ شود
                                        e.currentTarget.setPointerCapture?.(e.pointerId);
                                        pressActiveRef.current = true;      // ✅
                                        startRecording();
                                    }}
                                    onPointerUp={() => {
                                        pressActiveRef.current = false;     // ✅

                                        const heldMs = Date.now() - pressDownAtRef.current;
                                        // اگر فقط tap بود، پیام بده
                                        if (heldMs < HINT_TAP_MS) {
                                            showMicHint();
                                        }

                                        stopRecording();
                                    }}
                                    onPointerCancel={() => {
                                        pressActiveRef.current = false;     // ✅
                                        stopRecording();
                                    }}
                                    onPointerLeave={() => {
                                        pressActiveRef.current = false;     // ✅
                                        stopRecording();
                                    }}
                            >
                                <svg width="18" height="18" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g/><path d="M16.003 22.377a5.85 5.85 0 0 0 5.851-5.851V5.887a5.85 5.85 0 0 0-11.702 0v10.639a5.85 5.85 0 0 0 5.851 5.851M11.216 5.888c0-2.639 2.147-4.786 4.787-4.786s4.787 2.147 4.787 4.786v10.639c0 2.64-2.147 4.787-4.787 4.787s-4.787-2.147-4.787-4.787z" fill="#fff"/><path d="M23.978 11.207v5.319c0 4.399-3.579 7.978-7.978 7.978s-7.978-3.579-7.978-7.978v-5.319H6.958v5.319c0 4.83 3.81 8.776 8.581 9.018h-.068v5.354h-4.79v1.064h10.637v-1.064h-4.784v-5.354h-.073c4.771-.243 8.581-4.189 8.581-9.018v-5.319z" fill="#fff"/></svg>
                            </button>
                        ) : (
                            /* ➤ ارسال */
                            <button
                                onClick={handleSendMessage}
                                className={[
                                    chatStyle['icon-button'],
                                    chatStyle['icon-button--primary'],
                                ].join(' ')}
                                aria-label="Send"
                            >
                                <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" transform="scale(-1 1)" className={chatStyle['send-btn']}><path fill="#fff" fillRule="evenodd" d="M2.345 2.245a1 1 0 0 1 1.102-.14l18 9a1 1 0 0 1 0 1.79l-18 9a1 1 0 0 1-1.396-1.211L4.613 13H10a1 1 0 1 0 0-2H4.613L2.05 3.316a1 1 0 0 1 .294-1.071z" clipRule="evenodd"/></svg>
                            </button>
                        )}

                    </div>

                    

                </footer>
            }
        </div>
    );
};

export default WhatsAppChat;
